import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5661785a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5661785a')) {
      api.createRecord('5661785a', component.options)
    } else {
      api.reload('5661785a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5661785a&", function () {
      api.rerender('5661785a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N6jo8SCr4F4R/JS/comp/openstreetmap.vue"
export default component.exports